import trfService from '../services/trfService';

const escapeHtml = (v) =>
  String(v ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const formatDateTime = (value) => {
  const d = value ? new Date(value) : null;
  if (!d || Number.isNaN(d.getTime())) return '-';
  const pad = (n) => String(n).padStart(2, '0');
  const h = d.getHours() % 12 || 12;
  return `${pad(d.getDate())}-${MONTHS[d.getMonth()]}-${d.getFullYear()} ${pad(h)}:${pad(d.getMinutes())} ${d.getHours() < 12 ? 'AM' : 'PM'}`;
};

const TRF_CSS = `
  @page { size: A4; margin: 10mm; }
  * { box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  html, body { margin: 0; padding: 0; background: #fff; color: #1e293b; font-family: 'Segoe UI', Arial, Helvetica, sans-serif; font-size: 12px; }
  .trf-page { page-break-after: always; break-after: page; border: 1.5px solid #0f766e; border-radius: 10px; overflow: hidden; min-height: 270mm; position: relative; }
  .trf-page:last-child { page-break-after: auto; break-after: auto; }
  .trf-head { background: linear-gradient(135deg, #0f766e 0%, #0e7490 55%, #1d4ed8 100%); color: #fff; padding: 16px 20px; display: flex; align-items: center; gap: 14px; }
  .trf-logo { width: 52px; height: 52px; border-radius: 12px; background: rgba(255,255,255,0.18); border: 2px solid rgba(255,255,255,0.65); display: flex; align-items: center; justify-content: center; font-size: 20px; font-weight: 800; letter-spacing: 1px; flex-shrink: 0; }
  .trf-centre { font-size: 20px; font-weight: 800; letter-spacing: 0.3px; }
  .trf-centre-sub { font-size: 10.5px; opacity: 0.9; margin-top: 3px; }
  .trf-titlebar { background: #ecfeff; border-bottom: 2px solid #0e7490; padding: 9px 20px; display: flex; justify-content: space-between; align-items: center; }
  .trf-title { font-size: 15px; font-weight: 800; letter-spacing: 1.5px; color: #0f4c5c; }
  .trf-title small { display: block; font-size: 10px; letter-spacing: 0.5px; font-weight: 600; color: #0e7490; margin-top: 2px; }
  .trf-chips { display: flex; gap: 8px; align-items: center; }
  .trf-chip { background: #0f766e; color: #fff; border-radius: 999px; padding: 4px 12px; font-size: 11px; font-weight: 700; }
  .trf-chip--seq { background: #7c3aed; }
  .trf-body { padding: 16px 20px 0; }
  .trf-section { display: flex; align-items: center; gap: 8px; font-size: 11px; font-weight: 800; letter-spacing: 1.2px; text-transform: uppercase; color: #0f766e; margin: 0 0 8px; }
  .trf-section::after { content: ''; flex: 1; height: 1px; background: #99f6e4; }
  .trf-info { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 12px; margin-bottom: 18px; }
  .trf-cell { background: #f8fafc; border: 1px solid #e2e8f0; border-left: 4px solid #0e7490; border-radius: 6px; padding: 7px 10px; }
  .trf-cell.alt { border-left-color: #7c3aed; }
  .trf-cell .k { font-size: 9.5px; font-weight: 700; letter-spacing: 0.8px; text-transform: uppercase; color: #64748b; }
  .trf-cell .v { font-size: 13px; font-weight: 700; color: #0f172a; margin-top: 2px; word-break: break-word; }
  .trf-badge { display: inline-block; padding: 2px 10px; border-radius: 999px; font-size: 11px; font-weight: 800; background: #dcfce7; color: #166534; }
  .trf-badge--urgent { background: #fee2e2; color: #b91c1c; }
  .trf-tests { width: 100%; border-collapse: separate; border-spacing: 0; margin-bottom: 18px; border: 1px solid #99f6e4; border-radius: 8px; overflow: hidden; }
  .trf-tests th { background: #0f766e; color: #fff; padding: 8px 10px; text-align: left; font-size: 10.5px; letter-spacing: 0.8px; text-transform: uppercase; }
  .trf-tests td { padding: 9px 10px; border-top: 1px solid #e2e8f0; font-size: 12.5px; }
  .trf-tests tbody tr:nth-child(even) td { background: #f0fdfa; }
  .trf-tests td.n { font-weight: 800; color: #0f766e; text-align: center; }
  .trf-tests td.t { font-weight: 700; color: #0f172a; }
  .trf-pill { display: inline-block; background: #e0e7ff; color: #3730a3; border-radius: 999px; padding: 2px 10px; font-size: 10.5px; font-weight: 700; }
  .trf-box { border: 1px solid #cbd5e1; border-radius: 8px; padding: 6px 12px 2px; margin-bottom: 18px; }
  .trf-lines div { border-bottom: 1px dashed #94a3b8; height: 26px; }
  .trf-note { background: #fffbeb; border: 1px solid #fde68a; border-radius: 8px; padding: 8px 12px; font-size: 10.5px; color: #92400e; margin-bottom: 18px; }
  .trf-sign { display: flex; justify-content: space-between; gap: 30px; padding: 34px 20px 0; }
  .trf-sign div { flex: 1; border-top: 1.5px solid #334155; padding-top: 5px; text-align: center; font-size: 10.5px; font-weight: 600; color: #475569; }
  .trf-foot { position: absolute; left: 0; right: 0; bottom: 0; background: #0f766e; color: #ccfbf1; text-align: center; font-size: 9.5px; padding: 6px 10px; letter-spacing: 0.4px; }
`;

const initialsOf = (name) =>
  String(name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('') || 'LB';

const cell = (k, v, alt) =>
  `<div class="trf-cell${alt ? ' alt' : ''}"><div class="k">${escapeHtml(k)}</div><div class="v">${v}</div></div>`;

const buildPage = (doc, reg) => {
  const tests = (doc.tests || [])
    .map(
      (t, i) => `<tr><td class="n">${i + 1}</td><td class="t">${escapeHtml(t.itemName)}</td><td>${escapeHtml(t.itemCode || '-')}</td><td><span class="trf-pill">${escapeHtml(t.modality || '-')}</span></td></tr>`
    )
    .join('');
  const urgent = reg.priority && String(reg.priority).toLowerCase() !== 'routine';
  const seq = doc.total > 1 ? `<span class="trf-chip trf-chip--seq">TRF ${doc.sequence} of ${doc.total}</span>` : '';
  const centre = reg.centreName || 'Laboratory & Diagnostic Centre';
  return `<section class="trf-page">
    <div class="trf-head">
      <div class="trf-logo">${escapeHtml(initialsOf(centre))}</div>
      <div>
        <div class="trf-centre">${escapeHtml(centre)}</div>
        <div class="trf-centre-sub">${escapeHtml([reg.centreAddress, reg.centreContact].filter(Boolean).join('  |  '))}</div>
      </div>
    </div>
    <div class="trf-titlebar">
      <div class="trf-title">TEST REQUISITION FORM<small>RADIOLOGY &amp; IMAGING</small></div>
      <div class="trf-chips"><span class="trf-chip">${escapeHtml(doc.trfNo)}</span>${seq}</div>
    </div>
    <div class="trf-body">
      <div class="trf-section">Patient &amp; Registration</div>
      <div class="trf-info">
        ${cell('Patient Name', escapeHtml(reg.patientName))}
        ${cell('Patient ID', escapeHtml(reg.patientId))}
        ${cell('Age / Gender', escapeHtml(reg.ageGender))}
        ${cell('Registration No', escapeHtml(reg.ledgerTransactionNo))}
        ${cell('Registered On', escapeHtml(formatDateTime(reg.billDate)), true)}
        ${cell('Referring Doctor', escapeHtml(reg.doctorName || 'Self'), true)}
        ${cell('Priority', `<span class="trf-badge${urgent ? ' trf-badge--urgent' : ''}">${escapeHtml(reg.priority || 'Routine')}</span>`, true)}
      </div>
      <div class="trf-section">Requested Radiology Tests</div>
      <table class="trf-tests">
        <thead><tr><th style="width:44px;text-align:center">#</th><th>Test</th><th style="width:120px">Code</th><th style="width:160px">Modality</th></tr></thead>
        <tbody>${tests}</tbody>
      </table>
      <div class="trf-section">Clinical History / Indication</div>
      <div class="trf-box"><div class="trf-lines"><div></div><div></div><div></div></div></div>
      <div class="trf-note"><b>Note:</b> Please carry this form to the Radiology department. Remove metal objects and inform the technician if pregnant or allergic to contrast.</div>
    </div>
    <div class="trf-sign"><div>Referring Doctor Signature</div><div>Technician / Receptionist</div></div>
    <div class="trf-foot">${escapeHtml(centre)}  •  Registration ${escapeHtml(reg.ledgerTransactionNo)}  •  Computer generated requisition</div>
  </section>`;
};

/** Pure: builds the full printable HTML for every document of a prepare() result. */
export const buildTrfHtml = (prepared) => {
  const reg = prepared.registration || {};
  const pages = (prepared.documents || []).map((d) => buildPage(d, reg)).join('');
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>TRF ${escapeHtml(reg.ledgerTransactionNo)}</title><style>${TRF_CSS}</style></head><body>${pages}</body></html>`;
};

/**
 * Prints every TRF in ONE print job (one dialog, page break between TRFs) via a hidden iframe,
 * the same technique ReceiptModal uses. Resolves once print() has been invoked; the browser gives
 * no way to know whether paper actually came out.
 */
export const printTrfHtml = (html) =>
  new Promise((resolve, reject) => {
    let iframe;
    try {
      iframe = document.createElement('iframe');
      iframe.setAttribute('aria-hidden', 'true');
      Object.assign(iframe.style, { position: 'fixed', right: '0', bottom: '0', width: '0', height: '0', border: '0' });
      document.body.appendChild(iframe);
      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();
      setTimeout(() => {
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          resolve();
        } catch (e) {
          reject(e);
        } finally {
          setTimeout(() => iframe.remove(), 1000);
        }
      }, 150);
    } catch (e) {
      if (iframe) iframe.remove();
      reject(e);
    }
  });

const inFlight = new Set();

/**
 * Whole TRF flow for one registration: prepare (server resolves eligibility/mode/idempotency)
 * -> print -> record the outcome. Never throws; returns an outcome object for the caller to display.
 * Status: 'printed' | 'skipped' | 'busy' | 'print-failed' | 'error'.
 */
export const runTrfPrint = async (labNo, printType = 'MANUAL', printer = printTrfHtml) => {
  const key = `${labNo}|${printType}`;
  if (inFlight.has(key)) return { status: 'busy' };
  inFlight.add(key);
  try {
    let prepared;
    try {
      const res = await trfService.prepare(labNo, printType);
      if (!res.success) return { status: 'error', message: res.message || 'Could not prepare TRF.' };
      prepared = res.data;
    } catch (err) {
      return { status: 'error', message: err.response?.data?.message || err.message || 'Could not prepare TRF.' };
    }

    if (!prepared.documents || prepared.documents.length === 0) {
      return { status: 'skipped', reason: prepared.reason };
    }

    const trfNos = prepared.documents.map((d) => d.trfNo);
    const count = trfNos.length;
    try {
      await printer(buildTrfHtml(prepared));
    } catch (printErr) {
      const message = printErr?.message || 'Print could not be started.';
      try {
        await trfService.logPrint({ labNo, trfNos, printType, status: 'FAILED', errorMessage: message });
      } catch (_) { /* logging must not mask the print failure */ }
      return { status: 'print-failed', count, message };
    }

    let logged = true;
    try {
      await trfService.logPrint({ labNo, trfNos, printType, status: 'INITIATED' });
    } catch (_) {
      logged = false;
    }
    return { status: 'printed', count, logged };
  } finally {
    inFlight.delete(key);
  }
};

/** Maps an outcome to a user message. Returns null when nothing should be shown (silent auto skips). */
export const describeTrfOutcome = (outcome, printType = 'MANUAL') => {
  const auto = printType === 'AUTO';
  switch (outcome.status) {
    case 'printed':
      return {
        type: 'success',
        message: `${outcome.count} TRF${outcome.count > 1 ? 's' : ''} sent to the print dialog.${outcome.logged ? '' : ' (Print history could not be recorded.)'}`,
      };
    case 'skipped':
      if (auto) return null;
      if (outcome.reason === 'DISABLED') return { type: 'error', message: 'TRF printing is disabled in TRF Configuration.' };
      return { type: 'error', message: 'No eligible Radiology tests on this registration, so there is no TRF to print.' };
    case 'busy':
      return auto ? null : { type: 'error', message: 'TRF print is already in progress.' };
    case 'print-failed':
      return { type: 'error', message: `TRF print failed: ${outcome.message}. Use Print TRF on the receipt to retry.` };
    default:
      return { type: 'error', message: `TRF could not be prepared: ${outcome.message}. Use Print TRF on the receipt to retry.` };
  }
};
